import { backendClient } from "data/clients";

/**
 * Published APR per LoanTermsV2 row id, as a fraction (0.12 = 12%). The backend
 * serves percent; converting here keeps `Loan.apr` in the same unit as
 * `denormalizeRate` output, so the render sites need no conversion.
 *
 * This is the blended tranche rate PLUS the insurance spread, with the backend's
 * per-loan carve-outs applied — none of which the frontend can reconstruct. Rows
 * the dashboard filters out (non-public, closed, deduped clones) are absent by
 * construction, so callers must fall back rather than assume a hit.
 *
 * Never throws: this only upgrades a figure the loans page can already render,
 * so a backend outage degrades to the locally-derived blended rate.
 */
export async function getLoansAprByRowId(chainId: number): Promise<Record<string, number>> {
  try {
    const response = await backendClient.GET("/usdai/dashboard/loans-apr", {
      params: { query: { chainId: String(chainId) } },
      next: { revalidate: 60 * 5, tags: ["loans-apr"] },
    });

    if (!response.data) return {};

    return Object.fromEntries(Object.entries(response.data).map(([rowId, aprPercent]) => [rowId, aprPercent / 100]));
  } catch (error) {
    console.error(`Failed to fetch published loan APRs for chain ${chainId}:`, error);
    return {};
  }
}
